import React from "react";
import TablaCanjes from "./TablaCanjes";

export const Canjes = props => <TablaCanjes />;

export default Canjes;
